import React, { useCallback } from 'react';
import { Button, Row, Col } from 'reactstrap';

import {
  AudioPlayer, Intl, ModalForm,
} from 'components';

export default ( {
  uri, modalTitle, open, download, translateTitle = false, onClose, values,
} ) => {
  const downloadAudio = useCallback( () => {
    // window.open( uri, '_blank' ).focus();
    window.open(`${process.env.REACT_APP_API_URL}/v1/download_file?file=${uri}&fileName=${values}`, '_blank').focus();
    onClose();
  }, [uri] );
  return (
    <ModalForm
      title={modalTitle}
      translateTitle={translateTitle}
      size="md"
      open={open}
      values={values}
      showErrorsInHeader
      onClose={onClose}
      onSubmit={downloadAudio}
      footer={(
        <Button
          color="app-default"
          size="app-sm"
          className="font-weight-700"
          onClick={onClose}
        >
          <Intl id="okBtn" />
        </Button>
      )}
    >
      <Row className="my-5">
        <Col md={10} className="m-auto">
          <AudioPlayer
            src={uri}
          />
          {!!download
          && (
            <Button
              color="app-default"
              size="app-sm"
              block
              className="font-weight-700 mt-3"
            >
              <Intl id="download" />
            </Button>
          )}
        </Col>
      </Row>
    </ModalForm>
  );
};
